import { render, staticRenderFns } from "./OleMiss_AtomicEmission_ArgonResults.vue?vue&type=template&id=161d722f&scoped=true&"
import script from "./OleMiss_AtomicEmission_ArgonResults.vue?vue&type=script&lang=js&"
export * from "./OleMiss_AtomicEmission_ArgonResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161d722f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VForm,VSimpleTable})
